import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {NavController} from '@ionic/angular';
import {EventsService} from './events.service';
import {MsalService} from '@azure/msal-angular';
import {CompanyModel, DashboardModel, DelegateModel} from '../modules/team/models/delegate.model';
import {UserInfoModel} from './models/user-info.model';
import { AuthService as OktaAuthService} from '@auth0/auth0-angular';

@Injectable({
    providedIn: 'root'
})
export class AuthService {

    private token = null;
    private user: DelegateModel = null;
    private userType = null;
    private userCompanyId = null;
    private userCompany: CompanyModel = null;
    public appMobile = false;
    public appPlatform = 'web';
    public appVersion: any;
    public appVersionCode: any;
    public appVersionNumber: any;
    protected redirectUrl: string = null;

    constructor(
        private event: EventsService,
        private router: Router,
        private navCtrl: NavController,
        private msalService: MsalService,
        private oktaAuth: OktaAuthService,
    ) {
        event.subscribe('auth:getUserInfo', (userInfo) => {
            this.setUserInfo(userInfo);
        })
    }

    logout() {
        this.setToken(null);
        this.setUserType(null);
        this.setUserInfo(null);
        localStorage.removeItem('UserLanguage');
        this.event.publish('logout');

        this.msalService.logoutRedirect({
            // If in iframe, don't perform redirect to AAD
            onRedirectNavigate: () => {
                return false;
            }
        });

        this.oktaAuth.logout({
            openUrl: false
        });

        setTimeout(() => {
            console.log('logout and navigate to login');
            this.navCtrl.navigateRoot(['/login']);
        });
    }

    isLoggedin() {
        return (this.getToken() !== null);
    }

    getToken() {
        if (this.token === null) {
            this.token = localStorage.getItem('AuthToken');
        }
        return this.token;
    }

    setToken(token: string) {
        this.token = token;
        if (token === null) {
            localStorage.removeItem('AuthToken');
        } else {
            localStorage.setItem('AuthToken', token);
        }

    }

    clearRedirectUrl() {
        localStorage.removeItem('redirectUrl');
    }

    setRedirectUrl(url: string) {
        url = url ? url.replace('?sso=enabled', '').replace('&sso=enabled', '') : url;
        localStorage.setItem('redirectUrl', url);
        this.redirectUrl = url;
    }

    getRedirectUrl() {
        // Get from local storage for when the user logs in
        this.redirectUrl = localStorage.getItem('redirectUrl');
        return this.redirectUrl;
    }

    getUserType() {
        if (this.userType === null) {
            this.userType = localStorage.getItem('userType');
        }
        return this.userType;
    }

    setUserType(userType: string) {
        if (userType === null) {
            this.userType = null;
            localStorage.removeItem('userType');
        } else {
            this.userType = userType;
            localStorage.setItem('userType', userType);
        }
    }

    getUserCompanyId() {
        if (this.userCompany === null) {
            return +localStorage.getItem('userCompanyId');
        }
        return this.userCompany.id;
    }

    getUserCompanyDashboard() {
        if (this.user === null) {
            return localStorage.getItem('userCompanyDashboard') || 'classic';
        }

        if (
            (false && this.user.client_id === 131 && this.user.templates && !!this.user.templates.find((o) => o.template.uid === 'VMD'))
            || (this.user.client_id === 134 && this.user.templates && !!this.user.templates.find((o) => o.template.uid === 'TWOB'))
        ) {
            return 'inspire';
        }

        return !!this.user.dashboard ? 'multijourneys' : 'classic';
    }

    getUserCompanyEnabledSocial() {
        if (this.user === null) {
            return (localStorage.getItem('userCompanyEnabledSocial') || "false") === "true";
        }
        return (!!this.user.dashboard && !!this.user.dashboard.enabled_social && !!this.user.dashboard.social_url);
    }

    getUserCompanySocialUrl() {
        return this.user.dashboard && this.user.dashboard.social_url
          ? this.user.dashboard.social_url + '?i=' + this.user.meet_user
          : '';
    }

    getUserCompanyEnabledLeaderboard() {
        if (this.user === null) {
            return (localStorage.getItem('userCompanyEnabledLeaderboard') || "false") === "true";
        }
        return (!!this.user.dashboard && !!this.user.dashboard.enabled_leaderboard);
    }

    setUserInfo(user: UserInfoModel) {
        if (!user) {
            this.user = null;
            this.setUserCompanyInfo(null);
            this.setUserCompanyDashboardInfo(null);
        } else {
            this.user = user;
            this.setUserCompanyInfo(user.company);
            this.setUserCompanyDashboardInfo(user.dashboard);
        }
    }

    setUserCompanyInfo(company: CompanyModel) {
        if (!company) {
            this.userCompany = null;
            localStorage.removeItem('userCompanyId');
            localStorage.removeItem('userCompanyName');
        } else {
            this.userCompany = company;
            localStorage.setItem('userCompanyId', company.id.toString());
            localStorage.setItem('userCompanyName', company.name);
        }
    }

    setUserCompanyDashboardInfo(dashboard: DashboardModel) {
        if (!dashboard) {
            localStorage.setItem('userCompanyDashboard', 'classic');
            localStorage.setItem('userCompanyEnabledSocial', 'false');
            localStorage.setItem('userCompanyEnabledLeaderboard', 'false');
        } else {
            if (this.user.client_id === 134 && !!this.user.templates.find((o) => o.template.uid === 'TWOB')) {
                localStorage.setItem('userCompanyDashboard', 'inspire');
            } else {
                localStorage.setItem('userCompanyDashboard', 'multijourneys');
            }
            localStorage.setItem('userCompanyEnabledSocial', dashboard.enabled_social.toString());
            localStorage.setItem('userCompanyEnabledLeaderboard', dashboard.enabled_leaderboard.toString());
        }
    }

}
